import React from 'react';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import MoreLink from 'commonComponents/MoreLink/MoreLink';
import { getNewsImage } from 'lib/utils/imagesUtils';

import styles from './News.module.scss';

const News = ({ header, subheader, articles, more }) => {
  const headerProps = {
    header,
    subheader,
    anchor: 'news'
  };
  return ( 
    <section className={ styles.News }>
      <div className={ styles.content }>
        <PrimarySectionHeader { ...headerProps } />
        <div className={ styles.tiles }>
          { articles && articles.map((article) =>
            <Article
              { ...article }
              key={ article.title }                
              more={ more }
            />
          ) }
        </div>
      </div>
    </section>
  );
};

const Article = ({ title, subtitle, alt, text, photo, link, more }) => {
  return ( 
    <div className={ styles.Article }>
      <figure>
        <img src={ getNewsImage(photo) } alt={ alt } />
      </figure>
      <article>
        <h5>{ title }</h5>
        <h6>{ subtitle }</h6>
        <p>{ text }</p>
        <MoreLink label={ more } url={ link }
          target={ '_blank' }
        />
      </article>
    </div>
  );
};

export default News;
